// // IMPORT REACT
import 'react-app-polyfill/ie9';
import React from "react";
import { render } from 'react-dom';
import { BrowserRouter } from "react-router-dom";


// IMPORT CONTAINERS
import Routes from "./containers/Routes";

// IMPORT STYLES AND WEB FONT
import { ThemeProvider } from 'styled-components';
import './index.scss';

// eslint-disable-next-line import/no-webpack-loader-syntax
const sassVars = require('sass-extract-loader?{"plugins":["sass-extract-js"]}!./shared-variables.scss');
const WebFont = require('webfontloader');

WebFont.load({
  google: {
    families: ['Open Sans:400,700']
  }
});

const App = () => (
  <BrowserRouter>
    <ThemeProvider theme={sassVars}>
      {/* CONTAINER */}
      <Routes />
      {/* END CONTAINER */}
    </ThemeProvider>
  </BrowserRouter>
);
render(<App />, document.getElementById('root'));